import React from "react";
import { map } from "lodash";
import { connect } from "react-redux";

import FontIcon from "react-md/lib/FontIcons";
import Button from "react-md/lib/Buttons/Button";


import { installPackage } from "../../actions/resourceActions";

import {
  setActiveHost,
  setActiveServer,
  setActiveOrganization,
  setActivePackage
} from "../../actions/activeActions";
import {TouchTable} from "../../AtollonTheme/ReactElements";

const Table = ({
  history,
  packages,
  admin,
  host,
  server,
  organization,
  installPackage,
  setActiveHost,
  setActiveServer,
  setActiveOrganization,
  setActivePackage
}) => {

  let headerAsList = ["Název","Verze","Lokalizace","Status"];
  if( admin )
  {
      headerAsList.push("Akce");
  }

  return (
      <TouchTable
          headerAsList={headerAsList}
          elementsAsList={map(packages, (item, i) => {

            let actions = [item.name,item.version,item.locale,item.status];

            if( admin )
            {
                actions.push((item.status === "IDLE" || item.status === "FAILED" ? (
                    <div className="table-col actions">

                        <Button
                            raised
                            className="btn btn-primary"
                            onClick={() => {

                                // FIXME: pull out
                                let isEditingFromHostServerMenu = host && server;
                                if( isEditingFromHostServerMenu )
                                {
                                    setActiveHost(host);
                                    setActiveServer(server);
                                    setActiveOrganization(organization);
                                    setActivePackage(item);
                                    history.push("/package-new");
                                }
                                else
                                {
                                    setActiveOrganization(organization);
                                    setActivePackage(item);
                                    history.push("/package-new");
                                }
                            }}>Nainstalovat</Button>
                    </div>
                ): (<div />)
                ));
            }
            return actions;
          }
      )}
    />
  );
};

export default connect(null, {
  installPackage,
  setActiveHost,
  setActiveServer,
  setActiveOrganization,
  setActivePackage
})(Table);



// WEBPACK FOOTER //
// ./src/components/packages/Table.js